var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 3.58039L8.99039 15.0004L4.75039 10.7604L6.16039 9.35039L8.99039 12.1804L18.9904 2.18039L20.4004 3.58039ZM18.1904 8.62039C18.3204 9.19039 18.4004 9.79039 18.4004 10.4004C18.4004 14.8204 14.8204 18.4004 10.4004 18.4004C5.98039 18.4004 2.40039 14.8204 2.40039 10.4004C2.40039 5.98039 5.98039 2.40039 10.4004 2.40039C11.9804 2.40039 13.4404 2.86039 14.6804 3.65039L16.1204 2.21039C14.5004 1.07039 12.5304 0.400391 10.4004 0.400391C4.88039 0.400391 0.400391 4.88039 0.400391 10.4004C0.400391 15.9204 4.88039 20.4004 10.4004 20.4004C15.9204 20.4004 20.4004 15.9204 20.4004 10.4004C20.4004 9.21039 20.1804 8.07039 19.8004 7.01039L18.1904 8.62039Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.356efcd48e5200368d41c81924ca4748.svg";
export { ForwardRef as ReactComponent };